export const prop = 'relatedObjectImpacted';

export const config = (labels) => ({
	id: 'relatedObjectImpactedColumn',
	label: labels.relatedObjectImpacted,
	propName: prop,
	width: 'minmax(21rem, 3fr)',
	sortBy: prop
});
